import Addresses from './Addresses';

export default Addresses;
